import type { IconNode } from '../types';

/**
 * @name sunlounger-parasol-sun
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIyMCIgY3k9IjQiIHI9IjIiIC8+CiAgPHBhdGggZD0iTTIuNCAxNC40YTcgNyAwIDAgMSAxMy4yLTQuOFoiIC8+CiAgPHBhdGggZD0ibTkgMTIgMyA5IiAvPgogIDxwYXRoIGQ9Im0zIDIxIC43LTIuMWMuMi0uNS43LS45IDEuMy0uOWgxMmMuNSAwIDEuMy0uNCAxLjYtLjhMMjIgMTMiIC8+CiAgPHBhdGggZD0ibTIxIDIxLTMtMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/sunlounger-parasol-sun
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const sunloungerParasolSun: IconNode = [
  ['circle', { cx: '20', cy: '4', r: '2', key: '1oosvp' }],
  ['path', { d: 'M2.4 14.4a7 7 0 0 1 13.2-4.8Z', key: '1krbvs' }],
  ['path', { d: 'm9 12 3 9', key: '1nvpj' }],
  ['path', { d: 'm3 21 .7-2.1c.2-.5.7-.9 1.3-.9h12c.5 0 1.3-.4 1.6-.8L22 13', key: '12dkjb' }],
  ['path', { d: 'm21 21-3-3', key: 'wjr3av' }],
];

export default sunloungerParasolSun;
